import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_00.jpg";

const data: ReplicaItemType = {
  id: "advanced-potion-making-v2-prototype-text-block",
  name: "Prototype Text Block Advanced Potion Making V2 - Prince's Copy",
  nameFormatted: {
    primary: "Prototype Text Block",
    secondary: "Advanced Potion Making V2",
    tertiary: "Prince's Copy",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
